import React from "react";
import { Typography, FormControl, Box } from "@material-ui/core";

import { AccountContact } from "../../../api/services";
import { MultiContactSelector } from "./MultiContactSelector";

export const getContactName = (contact: AccountContact) => {
  const { title, forename, surname } = contact;
  return [title, forename, surname].filter((s) => s != null).join(" ");
};

export const ContactSelector: React.FC<{
  contacts: AccountContact[];
  onChange: (id: string) => void;
}> = ({ contacts, onChange }) => {
  if (!contacts.length) {
    return null;
  }
  const options = contacts.map((c) => ({
    name: getContactName(c),
    value: String(c.id),
  }));

  return (
    <Box mt={2}>
      <FormControl component="fieldset">
        {options.length === 1 ? (
          <SingleContact name={options[0].name} />
        ) : (
          <MultiContactSelector
            name="contact"
            options={options}
            onChange={onChange}
          />
        )}
      </FormControl>
    </Box>
  );
};

const SingleContact: React.FC<{ name: string }> = ({ name }) => (
  <>
    <Typography variant="caption" gutterBottom>
      Customer Name
    </Typography>
    <Typography variant="subtitle1" gutterBottom>
      {name}
    </Typography>
  </>
);
